module.exports = __webpack_public_path__ + "img/logo_original.6036b4d4.svg";